import { of, merge } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';

import axios from '../../utilities/axios';
import { primaryApi } from '../../utilities/apiEndpointUtility';

import {
	getInvitation,
	getInvitationCompleted,
	getInvitationFailed
} from './invitationSlice';

export const getInviteEpic = (action$) =>
	action$.pipe(
		ofType(getInvitation.type),
		mergeMap(async (action) => {
			const invitationId = action.payload;
			const response = await axios.get(
				`${primaryApi()}/api/v1/registration/${invitationId}`
			);

			switch (response && response.status ? response.status : null) {
				case 200:
					return response.data;
				default:
					throw response.data;
			}
		}),
		switchMap((res) => [getInvitationCompleted(res)]),
		catchError((error, source) =>
			merge(of(getInvitationFailed(error.message)), source)
		)
	);

export default [getInviteEpic];
